import React, { useState, useCallback } from "react";
import { AnnouncementContext } from "./useAnnouncement";

export const AnnouncementProvider = ({ children }: { children: React.ReactNode }) => {
  const [region1, setRegion1] = useState("");
  const [region2, setRegion2] = useState("");
  const [toggle, setToggle] = useState(false);

  const announce = useCallback((message: string, callback?: (() => void)|null,time=50) => {
    if (callback) callback();
 
    if (toggle) {
      setRegion1("");
      setRegion2("");
      setTimeout(() => setRegion1(message), time);
    } else {
      setRegion2("");
      setRegion1("");
      setTimeout(() => setRegion2(message), time);
    }

    setToggle(prev => !prev);
  }, [toggle]);

  const liveStyle: React.CSSProperties ={
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: 0,
    margin: "-1px",
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    whiteSpace: "nowrap",
    border: 0
  };

  return (
    <AnnouncementContext.Provider value={ { announce } }>
      { children }

      <div aria-live="polite" aria-atomic="true" style={ liveStyle }>
        { region1 }
      </div>

      <div aria-live="polite" aria-atomic="true" style={ liveStyle }>
        { region2 }
      </div>
    </AnnouncementContext.Provider>
  );
};
